module.exports = __webpack_public_path__ + "static/media/product-catalog-horizontal.acb3190c.png";